<template>
  <span>
    <svg
      v-if="name === 'callback'"
      width="19px"
      height="19px"
      viewBox="0 0 19 19"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <title>Shape</title>
      <desc>Created with Sketch.</desc>
      <g
        id="Mobile-Navigation"
        stroke="none"
        stroke-width="1"
        fill="none"
        fill-rule="evenodd"
      >
        <g
          id="Group-41-Copy"
          transform="translate(-13.000000, -9.000000)"
          fill="#FBFBFB"
        >
          <g id="Group-42">
            <g id="Group-50">
              <path
                d="M25.7932641,13.621 L30.4142641,9 L31.8282641,10.414 L27.2082641,15.036 L30.0002641,17.828 L23.0002641,17.828 L23.0002641,10.828 L25.7932641,13.621 Z M14.1142641,11.464 C14.7962641,10.782 16.8512641,10.669 16.8672641,11.029 C16.8822641,11.389 18.7182641,15.389 18.7352641,15.749 C18.7502641,16.11 17.5232641,17.339 17.1652641,17.699 C16.8092641,18.056 19.5652641,21.177 19.6162641,21.236 C19.6762641,21.288 22.7892641,24.05 23.1452641,23.694 C23.5032641,23.334 24.7302641,22.104 25.0892641,22.12 C25.4492641,22.136 29.4392641,23.977 29.7992641,23.992 C30.1592641,24.009 30.0452641,26.068 29.3642641,26.752 C28.7842641,27.334 25.7712641,29.45 20.5342641,25.671 C19.9592641,25.34 19.0492641,24.58 17.6702641,23.198 L17.6682641,23.196 L17.6652641,23.193 L17.6612641,23.189 C17.6602404,23.1883696 17.6592397,23.1877025 17.6582641,23.187 C16.2802641,21.804 15.5222641,20.892 15.1922641,20.317 C11.4222641,15.067 13.5332641,12.047 14.1142641,11.464 L14.1142641,11.464 Z"
                id="Shape"
              ></path>
            </g>
          </g>
        </g>
      </g>
    </svg>

    <svg
      v-if="name === 'reload'"
      width="25px"
      height="19px"
      viewBox="0 0 25 19"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <title>Shape</title>
      <desc>Created with Sketch.</desc>
      <g
        id="Mobile-Navigation"
        stroke="none"
        stroke-width="1"
        fill="none"
        fill-rule="evenodd"
        opacity="0.400000006"
      >
        <g
          id="Group-41-Copy"
          transform="translate(-156.000000, -9.000000)"
          fill="#000000"
        >
          <g id="Group-42">
            <g id="Group-52" transform="translate(144.000000, 0.000000)">
              <g id="Group-53" transform="translate(0.000000, -0.000007)">
                <path
                  d="M24,9.00000685 C29.3847763,9.00000685 33.75,13.3294099 33.75,18.6699992 L37,18.6699992 L32.7858333,22.8495847 L32.71,23.0000068 L28.3333333,18.6699992 L31.5833333,18.6699992 C31.5833333,14.5119025 28.1925,11.148894 24,11.148894 L24,9.00000685 Z M24.4183007,28.0000068 C19.2744721,28.0000068 15.1045752,23.6705986 15.1045752,18.3300122 L12,18.3300122 L16.0255991,14.1504289 L16.0980392,14.0000068 L20.2788671,18.3300122 L17.1742919,18.3300122 C17.1742919,22.4881067 20.4133987,25.8511133 24.4183007,25.8511133 C26.4155773,25.8511133 28.2255447,25.0023033 29.5305011,23.6377607 L31,25.1634698 C29.2579963,26.9820856 26.8886691,28.0031998 24.4183007,28.0000068 L24.4183007,28.0000068 Z M24,10.9704537 C22.1792453,10.9704537 20.5292453,11.7487775 19.3396226,13.0000068 L18,11.6009945 C19.5880431,9.93339872 21.747966,8.99707908 24,9.00000685 L24,10.9704537 L24,10.9704537 Z"
                  id="Shape"
                ></path>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>

    <svg
      v-if="name === 'bell'"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 29 29"
      width="29px"
      height="29px"
    >
      <g fill="none" fill-rule="evenodd">
        <circle cx="14.5" cy="14.5" r="14.5" fill="#6F9F13" />
        <path
          fill="#FFF"
          fill-rule="nonzero"
          d="M20.2375 12.5751328c0-3.96376135-2.1875-5.31209-4.2333333-5.61262108 0-.02030616.0041666-.04061231.0041666-.0649797C16.0083333 6.39800062 15.5541667 6 15 6c-.5541667 0-.9916667.39800062-.9916667.89753202 0 .02436739 0 .04467354.0041667.0649797-2.05.30459231-4.25 1.65698219-4.25 5.62074348C9.7625 17.204936 8.58333333 17.7004061 7 19h16c-1.575-1.3036551-2.7625-1.8031865-2.7625-6.4248672zM15 21c2.073501 0 3.7756286-.4627907 4-1h-8c.2166344.5372093 1.926499 1 4 1z"
        />
      </g>
    </svg>

    <svg
      v-if="name === 'clock'"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      width="16px"
      height="16px"
    >
      <path
        fill="#000"
        fill-rule="nonzero"
        d="M12.8596879 7.9649362c0-.3370213-.2697305-.6100426-.6022127-.6100426H8.57225532V3.6750071c0-.338156-.27438298-.6124255-.61231206-.6124255-.33815603 0-.612539.2742695-.612539.6124255v4.2875461c0 .3382695.27438297.612539.612539.612539h4.29787234c.3321418 0 .6018723-.2731348.6018723-.610156m1.8390922-.0038582c0 3.7217589-3.0166241 6.7388369-6.73758861 6.7388369-3.72119149 0-6.73758865-3.017078-6.73758865-6.7388369 0-3.7217589 3.01639716-6.73883687 6.73758865-6.73883687 3.72096451 0 6.73758861 3.01707797 6.73758861 6.73883687m1.2233759 0C15.922156 3.5642553 12.3579007 0 7.96119149 0 3.56425532 0 0 3.5642553 0 7.961078c0 4.3968227 3.56425532 7.961078 7.96119149 7.961078 4.39670921 0 7.96096451-3.5642553 7.96096451-7.961078"
        opacity=".2"
      />
    </svg>

    <svg
      v-if="name === 'eye'"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 16"
      width="24px"
      height="16px"
    >
      <path
        fill="#000"
        fill-rule="nonzero"
        d="M12.012 0C4.075 0 0 8 0 8s3.075 8 12.012 8c8.093 0 12.011-7.969 12.011-7.969S20.074 0 12.012 0zm.018 13c-2.902 0-5-2.188-5-5 0-2.813 2.098-5 5-5s5 2.187 5 5c0 2.812-2.098 5-5 5zm0-8c-1.658.003-3 1.393-3 3 0 1.606 1.342 3 3 3s3-1.395 3-3c0-1.608-1.342-3.003-3-3z"
        opacity=".2"
      />
    </svg>
  </span>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      required: true
    }
  }
};
</script>
